import { render, staticRenderFns } from "./Product6.vue?vue&type=template&id=df70a18e&scoped=true&"
import script from "./Product6.vue?vue&type=script&lang=js&"
export * from "./Product6.vue?vue&type=script&lang=js&"
import style0 from "./Product6.vue?vue&type=style&index=0&id=df70a18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df70a18e",
  null
  
)

export default component.exports